import { createContext, useContext, useMemo, type ReactNode } from "react";
import type { ApiConfig } from "./query";

const ApiConfigContext = createContext<ApiConfig | null>(null);

export function ApiConfigProvider({ children, config }: { children: ReactNode; config: ApiConfig }) {
  const { tenant, authenticatedFetch } = config;
  const tenantId = tenant?.tenantId;
  const apiBaseUrl = tenant?.apiBaseUrl;
  const memoizedConfig = useMemo<ApiConfig>(
    () => ({
      tenant: tenantId && apiBaseUrl ? { tenantId, apiBaseUrl } : undefined,
      authenticatedFetch,
    }),
    [tenantId, apiBaseUrl, authenticatedFetch],
  );
  return <ApiConfigContext.Provider value={memoizedConfig}>{children}</ApiConfigContext.Provider>;
}

export function useApiConfig(): ApiConfig {
  const context = useContext(ApiConfigContext);
  if (!context) {
    throw new Error("useApiConfig must be used within ApiConfigProvider");
  }
  return context;
}
